export default [
	{
		name: "tutorReviewCenter",
		path: "review-center",
		component: () => import("../pages/TutorReviewCenter.vue"),
	},
];
